import React from 'react';
import styles from './style.module.css';
import StepOneForm from '../../components/forms/step-one';
import InfoBox from '../../../../common/components/info-box';

const tooltip = {
    title: 'Do you know the difference between gross and net income?',
    content: <span>Gross income is your total earnings <strong>before</strong> taxes, employment insurance and your Canadian Pension Plan deductions are subtracted. Net income is your earnings <strong>after</strong> these deductions.</span>
};

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Monthly Net Income</p>
        <h1 className={styles.mainTitle}>Income</h1>
        <p className={styles.text}>For best results, it’s recommended that you enter 100% of your <strong>net income</strong>.</p>
        <StepOneForm />
        <InfoBox
            title={tooltip.title}
            content={tooltip.content}
        />
    </div>
);
